import { Checkbox, Link, TableRow } from "@mui/material";

import { StyledTableCell } from "../../../common/components/functional/simpleTable/styled";
import {
  formatCellValue,
  SimpleTableCell,
  SimpleTableLinkCell,
  SimpleTableTextCell,
} from "../../../common/components/functional/simpleTable/cellHelpers";

interface Props {
  rowId: string;
  row: SimpleTableCell[];
  selected: boolean;
  onSelect: (wageReportId: string, selected: boolean) => void;
}

export const WageReportRowItem = ({
  row,
  rowId,
  selected,
  onSelect,
}: Props) => {
  const renderCell = (field: any, i: number) => {
    switch (field.type) {
      case "link":
        return (
          <SimpleTableLinkCell
            key={i}
            width={field.width}
            value=""
            canEdit={!rowId}
            inputProps={{
              startAdornment: (
                <Link
                  onClick={() => {
                    field.onClick && field.onClick();
                  }}
                  sx={{ paddingLeft: "12px", cursor: "pointer" }}
                  {...field?.linkProps}
                >
                  {field.value}
                </Link>
              ),
            }}
          />
        );
      case "icon":
        return (
          <SimpleTableTextCell
            key={i}
            value={""}
            canEdit={false}
            inputProps={{
              startAdornment: field.value,
            }}
          />
        );

      default:
        return (
          <SimpleTableTextCell
            key={i}
            value={formatCellValue(field)}
            canEdit={false}
            color={field.color}
          />
        );
    }
  };

  return (
    <>
      <TableRow>
        <StyledTableCell>
          <Checkbox
            checked={selected}
            onClick={() => onSelect(rowId, !selected)}
          />
        </StyledTableCell>
        {row.map((field, i) => renderCell(field, i))}
      </TableRow>
    </>
  );
};
